import React, { createContext, useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import authService from '../features/auth/auth-service';
import { CacheService } from '../services/cache-service';
import tenantService, { Tenant } from '../services/tenant-service';
import { useQuery } from '../hooks/use-query';
import { useNavigate } from 'react-router-dom';

export const TenantContext = createContext({ items: [] as Tenant[], current: {} } as TenantState);

type TenantStateProps = {
  children: JSX.Element;
};

export type TenantState = {
  items: Tenant[];
  current: Tenant;
  setTenant?(tenant: Tenant): void;
};

export const goldMaster = 'gold.master';

export const TenantStateProvider = (props: TenantStateProps): JSX.Element => {
  const queryClient = useQueryClient();
  const [tenantState, setTenantState] = useState<TenantState>({ items: [], current: {} as Tenant });
  const tenants = useQuery<Tenant[]>({ path: '/tenants/all', options: { enabled: authService.isAuthed(), keepPreviousData: true } });
  const navigate = useNavigate();

  useEffect(() => {
    if (authService.isAuthed() && Array.isArray(tenants.data)) {
      setTenantState({
        items: tenants.data,
        current: CacheService.get('pdc.tenant.id') === goldMaster
          ? { id: CacheService.get('pdc.tenant.id'), name: CacheService.get('pdc.tenant.name') } as Tenant
          : tenants.data?.find(tenant => tenant.id === CacheService.get('pdc.tenant.id')) as Tenant
      });
    }
  }, [tenants.data]);

  useEffect(() => {
    void (async (): Promise<void> => {
      await queryClient.invalidateQueries();
    })();
  }, [tenantState.current?.id]);

  const setTenant = (tenant: Tenant): void => {
    tenantService.setTenant(tenant);
    navigate('/configurations');
    setTenantState({ ...tenantState, current: tenant });
  };

  return <TenantContext.Provider value={{ ...tenantState, setTenant }}>{props.children}</TenantContext.Provider>;
};
